var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeartIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 458.54 461.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m298.9,97.53c17.36,1.43,33.13,7.19,47.06,17.68,14.3,10.76,24.14,24.87,29.96,41.67,2.76,7.96,4.5,16.27,4.36,24.82.59,2.04.16,4.12.29,6.17-.1,1.23.23,2.48-.25,3.68-1.39,17.04-7.19,32.43-17.43,46.13-1.03,1.38-2.09,2.76-3.3,3.97-16.28,16.33-32.32,32.92-49,48.84-11.56,11.03-22.42,22.76-34.18,33.54-9.99,9.15-19.14,19.14-29.04,28.37-3.29,3.06-6.47,6.26-9.86,9.18-5.01,4.32-15.64,5.41-21.98-1.5-11.1-12.1-23.27-23.13-34.31-35.29-8.25-9.09-17.53-17.22-25.89-26.21-10.25-11.02-21.36-21.2-31.52-32.28-4.53-4.94-9.55-9.32-14.23-14.06-9.87-10.01-18.72-20.77-24.67-33.67-4.35-9.42-7.04-19.17-7.33-29.65-.33-11.93.97-23.55,5.2-34.73,3.67-9.67,8.89-18.42,15.65-26.35,10.7-12.55,23.92-21.09,39.46-26.22,6.85-2.26,13.92-3.49,21.1-4.09,1.37-.5,2.79-.14,4.19-.25,1.41,0,2.82,0,4.23,0,1.4.11,2.83-.26,4.21.25,22.31,1.82,41.33,10.83,57.29,26.53,16.03-15.9,35.06-24.81,57.39-26.54,1.37-.5,2.8-.14,4.2-.25,1.61,0,3.22,0,4.83,0,1.2.1,2.42-.23,3.59.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.31,188.08c0-2.13-.01-4.25-.02-6.38,1.29,2,.43,4.19.57,6.3-.14.32-.32.35-.55.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.4,97.59c-1.65,0-3.29-.02-4.94-.03-.2-.15-.26-.29-.17-.4.08-.1.16-.15.25-.15,1.59.01,3.18.03,4.78.04.26.08.35.19.29.32-.07.14-.14.21-.21.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.18,97.58c-1.4-.02-2.79-.03-4.19-.05,1.31-1.11,2.83-.47,4.27-.5.19.15.24.28.15.39-.08.1-.15.15-.23.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.18,97.58c.03-.18.05-.36.08-.54,1.37-.01,2.73-.03,4.1-.04.22.09.31.2.26.33-.05.14-.11.21-.18.21-1.42.02-2.84.03-4.27.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.44,97.53c-.03-.18-.06-.36-.09-.54,1.43.09,2.95-.56,4.25.55-1.39,0-2.78,0-4.17,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.54,97.01c-.03.18-.06.37-.08.55-1.39,0-2.79-.02-4.18-.03,1.31-1.11,2.83-.46,4.26-.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.4,97.59c-.02-.18-.05-.36-.08-.54,1.22-.04,2.5-.55,3.58.48-1.17.02-2.34.04-3.5.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.31,188.08c.18-.03.36-.06.55-.09-.04,1.21.5,2.5-.53,3.56,0-1.16-.01-2.32-.02-3.48Z",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIconWhite);
export default __webpack_public_path__ + "static/media/heart_icon_white.e7695631850b1fd812017e8356a43e1c.svg";
export { ForwardRef as ReactComponent };